<template>
  <section
    v-if="articles.data.length"
  >
    <MainTitle
      title="Friss cikkek"
      subtitle="Tallózó"
      sublink="/tallozo"
    />
    <div
      v-for="(item, index) in articles.data"
      :key="$unique() + index"
      class="flex flex-col lg:flex-row bg-gray-light pt-[15px]"
      :class="{'pb-[30px]':index===articles.data.length-1}"
    >
      <div class="w-full bg-white mr-1">
        <div class="w-full bg-white pt-[18px] pb-[5px] px-[25px]">
          <p class="font-semibold text-lg">
            {{ item.uptitle | removeHtml }}
          </p>
          <nuxt-link
            :to="'/tallozo/cikk/' + item.id + '/' + item.slug"
          >
            <h3 class="font-source-serif-pro text-red text-xl font-semibold">
              {{ item.title | removeHtml }}
            </h3>
          </nuxt-link>
          <p class="font-semibold text-lg">
            {{ item.subtitle | removeHtml }}
          </p>
        </div>
        <div class="w-full pb-[15px] pt-[5px] px-[25px]">
          <p>{{ item.description }}</p>
        </div>
      </div>
      <div class="w-full lg:w-[290px] py-[10px] px-[25px] bg-white text-left flex content-center items-center">
        <figure
          :class="{ 'lg:hidden': !getMainImgObj(item)}"
          class="my-auto mx-auto hidden lg:block"
        >
          <RePictureSet
            :image="getMainImgObj(item)"
            image-class="px-[37px] lazyload"
            sizes="180px"
          />
          <p class="text-center pt-[10px]">
            {{
              dtformat(
                item.published_at,
                "YYYY-MM-DD",
                "YYYY. MMMM D."
              )
            }}
          </p>
        </figure>
        <figure
          :class="{ 'lg:block': !getMainImgObj(item)}"
          class="block lg:hidden my-auto bg-white"
        >
          <h5 class="text-left font-semibold">
            {{
              item.source.name
                ? item.source.name
                : "Nincs forrás megadva"
            }}
          </h5>
          <p class="text-left">
            {{
              dtformat(
                item.published_at,
                "YYYY-MM-DD",
                "YYYY. MMMM D."
              )
            }}
          </p>
        </figure>
      </div>
    </div>
  </section>
</template>
<script>
const MainTitle = () => import("~/components/folkradio/MainTitle.vue")
import RePictureSet from '~/components/rxt/recomponent/RePictureSet.vue'

export default {
  components: {
    MainTitle,
    RePictureSet
  },
  filters: {
    removeHtml (value) {
      // const div = document.createElement('div')
      // div.innerHTML = value
      // return div.textContent || div.textContent || ''
      return value !== null ? value.replace(/<[^>]*>?/gm, '') : ''
    }
  },
  data () {
    return {
      articles: {
        data: []
      }
    }
  },
  fetch(){
    this.$axios
      .get("gleaners?filter[featured]=0&sort=-published_at,-updated_at&limit=3").then(response => {
        this.articles = response.data;
    })
  },
  methods: {
    dtformat(date, from, to) {
      return this.$moment(date, from).format(to);
    },
    getMainImgObj(article) {
      // if (article.images && article.images.length) {
      //   return article.images[0].url
      // }
      if (article.source && article.source.thumbnail) {
        return article.source.thumbnail;
      }
      return null;
    },
    getMainImg(article) {
      // if (article.images && article.images.length) {
      //   return article.images[0].url
      // }
      if (article.source && article.source.thumbnail) {
        return article.source.thumbnail.url;
      }
      return null;
    },
  }
}
</script>
